import * as yup from "yup";

import { string } from "@/utils/validation/schemas/general.RHF";

export const AddressBookModalValidationSchema = yup.object({
    addressId: string()
});

export type AddressBookModalFormValues = yup.InferType<
    typeof AddressBookModalValidationSchema
>;
